
export default {
   name:"SiteBanner",
   props: {
    title: String,
  },
}
